import { render, staticRenderFns } from "./WhatTypeOfFramesFormPart.PD-10940.vue?vue&type=template&id=27011d23"
import script from "./WhatTypeOfFramesFormPart.PD-10940.vue?vue&type=script&lang=js"
export * from "./WhatTypeOfFramesFormPart.PD-10940.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports